import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface BrandWordmarkProps {
  href?: string;
  className?: string;
  iconClassName?: string;
  textClassName?: string;
  dark?: boolean;
  showText?: boolean;
}

function BrandWordmarkInner({
  className,
  iconClassName,
  textClassName,
  dark = false,
  showText = true,
}: Omit<BrandWordmarkProps, 'href'>) {
  const primaryText = dark ? 'text-brand-offwhite' : 'text-brand-charcoal';

  return (
    <div className={cn('flex items-center gap-3', className)}>
      <img
        src="/images/logos/brand-logo-pattern-256.png"
        alt="The Recovery Directory"
        width="40"
        height="40"
        decoding="async"
        className={cn('h-10 w-10 rounded-lg object-contain', iconClassName)}
      />
      {showText ? (
        <span
          className={cn(
            '[font-family:var(--font-display)] whitespace-nowrap text-[0.96rem] leading-none tracking-[0.01em] sm:text-[1.04rem]',
            primaryText,
            textClassName,
          )}
        >
          The Recovery Directory
        </span>
      ) : null}
    </div>
  );
}

export function BrandWordmark(props: BrandWordmarkProps) {
  const { href = '/', dark = false, ...rest } = props;

  if (!href) {
    return <BrandWordmarkInner dark={dark} {...rest} />;
  }

  return (
    <Link
      to={href}
      className={cn(
        'inline-flex rounded-xl px-2 py-1.5 transition-colors',
        dark ? 'hover:bg-white/8' : 'hover:bg-white/60',
      )}
    >
      <BrandWordmarkInner dark={dark} {...rest} />
    </Link>
  );
}
